import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import TextInput from '@shared/components/forms/inputs/input/input.vue';
import Checkbox from '@shared/components/forms/inputs/checkbox/checkbox.vue';
import { Login } from '@auth/interfaces/login';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { Subscription } from 'rxjs';
import { AuthState } from '@auth/interfaces/auth-state';
import { State, Action, Getter } from 'vuex-class';

const namespace: string = 'auth';

@Component({
  name: 'bpc-form-login',
  components: {
    'bpc-input': TextInput,
    'bpc-checkbox': Checkbox,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class FormLogin extends Vue {
  // We set here the vuex utilities
  @State('auth') auth: AuthState;
  @Action('login', { namespace }) vuexLogin;
  // @Getter('authToken', { namespace }) authToken: string;
  // @Mutation('logout', { namespace }) logout;

  @Prop({ type: String, default: null }) readonly recaptcha: string;
  @Prop(String) readonly tenantAlias: string;
  @Prop({ type: Boolean, default: true }) readonly withRedirect: boolean;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  public formModel: Login = new Login();

  public loginSubscription: Subscription;

  emailAttributes: object = {
    fieldAttributes: {
      description: "We'll never share your email with anyone else.",
    },
    placeholder: this.$t('global.header.login_widget.email_placeholder'), //'Enter your email...',
    rules: ['required'],
    ...this.getCommonAttributes('email'),
    showLabel: false,
  };

  passwordAttributes: object = {
    fieldAttributes: {
      type: 'password',
    },
    placeholder: this.$t('global.header.login_widget.password_placeholder'), //'Enter your password ...',
    rules: ['required'],
    ...this.getCommonAttributes('password'),
    showLabel: false,
  };
  keepLoginAttributes: object = {
    label: 'Keep me logged in',
    ...this.getCommonAttributes('keepLogin'),
    showLabel: false,
  };

  get resetRecaptcha() {
    return this.$store.getters['auth/resetRecaptcha'];
  }
  async login(): Promise<boolean> {
    const isValid = await this.$refs.observer.validate();
    if (isValid) {
      if (this.loginSubscription) {
        this.loginSubscription.unsubscribe();
      }
      this.formModel.recaptcha = this.recaptcha;
      this.formModel.tenantAlias = this.tenantAlias || null;
      try {
        const res = await this.vuexLogin({
          formModel: this.formModel,
          tenantAlias: this.tenantAlias || null,
          redirect: this.withRedirect,
        });
        if (res) {
          this.$emit('success-login', res);
        }
        return res;
      } catch (error) {
        console.log(error);
        return false;
      }

      // if (this.isLoggedIn) {
      //   this.$router.push({ name: 'admin-contacts' });
      // }
    }
  }

  private getCommonAttributes(name: string): object {
    return {
      id: `${name}`,
      showLabel: true,
      labelClass: 'label-class',
      labelAttributes: {
        for: `${name}`, // Set to the ID of the singular form-control in the form-group.
        // Do not set a value if there is more than one form control in
        // the group.
        cols: 12, // Number of columns for the label width xs screens and up
        'cols-sm': 12, // Number of columns for the label width sm screens and up
        'cols-md': 12, // Number of columns for the label width md screens and up
        'cols-lg': 12, // Number of columns for the label width lg screens and up
        'cols-xl': 12, // Number of columns for the label width xl screens and up
        'align-sm': 'left', //Text alignment 'left', 'center', 'right' for the label sm screens and up
        'align-md': 'left', //Text alignment 'left', 'center', 'right' for the label md screens and up
        'align-lg': 'left', //Text alignment 'left', 'center', 'right' for the label lg screens and up
        'align-xl': 'left', //Text alignment 'left', 'center', 'right' for the label xl screens and up
        'sr-only': false, // to have the label size match the form control size
        align: 'right', // Text alignment 'left', 'center', 'right' for the label xs screens and up
        size: 'md', // Sets the text size of the label: 'sm', 'md' (default) or 'lg'. Use this prop
      },
      name: `${name}`,
      fieldClass: 'input-class',
      state: false, // Controls the validation state of the feedback.
      // 'true' + showError force shows valid-feedback,
      // 'false' + showFeedback force shows invalid feedback,
      // 'null' does not force show the feedback
      veeValidation: true,
      showError: true,
      errorClass: 'error-class',
      errorAttributes: {},
      error: 'error message',
      showHelp: false,
      helpClass: 'help-class',
      helpAttributes: {},
      help: `${name} help`,
      showFeedback: true,
      feedbackClass: 'feedback-class',
      feedbackAttributes: {},
      feedback: 'This is only for feedback',
    };
  }

  @Watch('resetRecaptcha')
  onChangeResetRecaptcha() {
    if (this.resetRecaptcha === true) {
      this.$emit('reset-recaptcha');
    }
  }
}
